export default {
  props: {
    /**
     * Override this, depending on the use case
     * for example, if the modelValue is an object, then the default modelValue should be an empty object
     */
    modelValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dValue: undefined,
      holdEmitInput: false
    }
  },
  watch: {
    modelValue: {
      handler (val, oldVal) {
        if (val === oldVal) return
        this.dValue = val
      },
      // immediate: true,
      deep: true
    },
    dValue: {
      handler (val, oldVal) {
        if (val === oldVal) return
        if (this.holdEmitInput) return
        this.$emit('update:modelValue', val)
      },
      // immediate: true,
      deep: true
    }
  }
}
